import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FuseConfirmationModule } from '@src/@fuse/services/confirmation';
import { FuseMediaWatcherModule } from '@src/@fuse/services/media-watcher/media-watcher.module';
import { FuseSplashScreenModule } from '@src/@fuse/services/splash-screen/splash-screen.module';
import { FuseTailwindConfigModule } from '@src/@fuse/services/tailwind/tailwind.module';
import { FuseUtilsModule } from '@src/@fuse/services/utils/utils.module';
import { FuseAlertModule } from './components/alert';

@NgModule({
    imports  : [
        FuseConfirmationModule,
        FuseMediaWatcherModule,
        FuseSplashScreenModule,
        FuseTailwindConfigModule,
        FuseUtilsModule,
        FuseAlertModule,
    ],
    providers: [
        {
            // Disable 'theme' sanity check
            provide : MATERIAL_SANITY_CHECKS,
            useValue: {
                doctype: true,
                theme  : false,
                version: true
            }
        },
        {
            // Use the 'outline' appearance on Angular Material form fields by default
            provide : MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline'
            }
        }
    ]
})
export class FuseModule
{
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: FuseModule)
    {
        if ( parentModule )
        {
            throw new Error('FuseModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
